<template>
  <div style="width:100%; height: 100%; max-height:800px">
    <v-btn @click="saveLayout" fab dark x-small color="blue">
      <v-icon>mdi-content-save</v-icon>
    </v-btn>
    <v-btn @click="autoLayout" fab dark x-small color="green">
      <v-icon>mdi-auto-fix</v-icon>
    </v-btn>
    <div style="width:100%; height: 100%" id="cy"></div>
    <div style="display:none">
      <pre>{{ focusedTask }} </pre>
      <pre>{{ getelements[0] }}</pre>
    </div>
  </div>
</template>

<script>
import cytoscape from "cytoscape";
import nodeHtmlLabel from "cytoscape-node-html-label";
import debounce from "debounce";
// import dagre from "cytoscape-dagre";
// import klay from "cytoscape-klay";
import elk from "cytoscape-elk";
import edgehandles from "cytoscape-edgehandles";
import $ from "jquery";
import contextMenus from "cytoscape-context-menus";
import "cytoscape-context-menus/cytoscape-context-menus.css";
import * as api from "./api";

function htmlEntities(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
let cy = null;
function diff(num1, num2) {
  if (num1 > num2) {
    return num1 - num2;
  } else {
    return num2 - num1;
  }
}

// function dist(p0, p1) {
//   var deltaX = diff(p0.x, p1.x);
//   var deltaY = diff(p0.y, p1.y);
//   var dist = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
//   return dist;
// }
var doubleClickDelayMs = 350;
var previousTapStamp;
let layoutDone = false;
setInterval(() => {
  if (layoutDone) {
    if (cy) {
      const nodes = cy.nodes();
      nodes.forEach((n0) => {
        nodes.forEach((n1) => {
          if (n0.grabbed() || n1.grabbed()) return;
          if (!(n0.data().title && n1.data().title)) return;
          if (n0 === n1) return;
          const p0 = n0.position();
          const p1 = n1.position();
          // const dinstance = dist(p0, p1);
          const miny = 150;
          const minx = 250;
          if (diff(p0.y, p1.y) < miny && diff(p0.x, p1.x) < minx) {
            if (diff(p0.y, p1.y) < miny) {
              if (p0.y < p1.y) {
                n0.position("y", p0.y - 10);
                n1.position("y", p1.y + 10);
              } else {
                n0.position("y", p0.y + 10);
                n1.position("y", p1.y - 10);
              }
            }
            if (diff(p0.x, p1.x) < minx) {
              if (p0.x < p1.x) {
                n0.position("x", p0.x - 10);
                n1.position("x", p1.x + 10);
              } else {
                n0.position("x", p0.x + 10);
                n1.position("x", p1.x - 10);
              }
            }
          }
        });
      });
    }
  }
}, 30);

cytoscape.use(contextMenus, $);
cytoscape.use(elk);
cytoscape.use(edgehandles);

let focusedNode = null;
let creatingRequiredToArrow = null;
let creatingDependsOnArrow = null;
let tmpEdge = null;
let handle = null;
let nodePositions = null;
const layoutOpts = {
  name: "elk",
  animate: false,
  // animationDuration: 1000,
  padding: 100,
  nodeDimensionsIncludeLabels: false,
  // nodeLayering: "INTERACTIVE",
  // nodePlacement: "INTERACTIVE",
  // transform: function(node, pos) {
  //   console.log(node);
  //   console.log("transforming pos", pos);
  //   if (node.data().x) {
  //     return { x: node.data().x, y: node.data().y };
  //   } else {
  //     return pos;
  //   }
  // },
  elk: {
    zoomToFit: true,
    // algorithm: "mrtree",
    separateConnectedComponents: false,
    scaleFactor: 1.5,
    iterationLimit: 0,
  },
};

nodeHtmlLabel(cytoscape);
export default {
  name: "CyView",
  components: {},
  props: {
    currentBoardId: String,
    tasks: Array,
    deps: Array,
    loadingBoard: Boolean,
    focusedTask: Object,
  },
  computed: {
    getelements: function () {
      const elements = [];
      elements.push(
        ...this.tasks.map((t) => {
          const obj = { data: { ...t }, classes: "tnode" };
          if (t.x) {
            obj.position = { x: t.x, y: t.y };
          }
          return obj;
        })
      );
      elements.push(
        ...this.deps
          .filter((d) => {
            const t1 = this.tasks.find((t) => t.id === d.task_id);
            const t2 = this.tasks.find((t) => t.id === d.depends_on_id);
            return t1 && t2;
          })
          .map((d) => ({
            data: {
              id: `${d.depends_on_id}-${d.task_id}`,
              source: d.depends_on_id,
              target: d.task_id,
              d,
            },
          }))
      );
      return elements;
    },
  },
  data: () => ({
    cy: null,
    zoom: null,
    pan: null,
    cyInterval: null,
  }),
  watch: {
    tasks: function () {
      this.drawsCyto = this.drawsCyto.bind(this);
      this.$nextTick(() => this.drawsCyto());
    },
    focusedTask: function () {
      if (focusedNode) {
        focusedNode.unactivate();
      }
      focusedNode = [...cy.nodes()].find(
        (n) => n.data().id === this.focusedTask.id
      );

      cy.center(focusedNode);
      focusedNode.activate();
    },
  },
  // updated: function () {},
  mounted: function () {
    this.drawsCyto = this.drawsCyto.bind(this);
    this.$nextTick(() => this.drawsCyto());
  },
  beforeDestroy: function () {
    console.log("destroying");
  },
  methods: {
    saveLayout: async function () {
      nodePositions = cy.nodes().map((n) => {
        const task = n.data();
        if (task.title) {
          return {
            id: task.id,
            x: n.position().x,
            y: n.position().y,
          };
        }
      });
      window.nodePositions = nodePositions;
      await api.postLayout(this.currentBoardId, nodePositions);
    },
    autoLayout: function () {
      layoutDone = false;
      cy.layout(layoutOpts).run();
      layoutDone = true;
      setTimeout(() => {
        this.saveLayout();
      }, 1000);
    },

    drawsCyto: async function () {
      layoutDone = false;
      const elements = this.getelements;
      const cyDoc = {
        container: document.getElementById("cy"), // container to render in
        elements,

        style: [
          // the stylesheet for the graph
          {
            selector: "node",
            style: {
              width: () => {
                return 200;
              },
              height: () => {
                return 100;
              },
              shape: "rectangle",

              "background-color": (node) => {
                const task = node.data();
                if (!task.title) {
                  return;
                }
                if (task.done) {
                  return "#ccc";
                }
                if (task.paused) {
                  return "#EEAA00";
                }
                const deps = task.dependsOn;
                if (
                  deps.filter((d) => {
                    return !d.done;
                  }).length === 0
                ) {
                  return "#5f5";
                } else {
                  let deps2 = 0;
                  deps
                    .filter((d) => {
                      return !d.done;
                    })
                    .forEach((d) => {
                      deps2 += d.dependsOn.filter((d) => !d.done).length;
                    });
                  if (deps2 === 0) {
                    return "#ff5";
                  }
                  return "#f99";
                }
                // return node.incomers().filter((n) => n.data().done).length === 0
                //   ? "#5f5"
                //   : "#f55";
              },
              // label: "data(title)",
            },
          },
          {
            selector: "edge",
            style: {
              width: "4",
              "curve-style": "bezier",
              "control-point-step-size": 10,
              "line-color": "#ccc",
              "target-arrow-color": "#f00",
              "target-arrow-shape": "triangle",
              "line-fill": "linear-gradient",
              "line-gradient-stop-colors": "gray yellow",
              "line-gradient-stop-positions": "50%",
              // "background-gradient-stop-positions": "25 75 80",
            },
          },
        ],

        // layout: layoutOpts,
      };
      cy = cytoscape(cyDoc);
      cy.minZoom(0.2);
      cy.maxZoom(0.8);
      cy.zoom(this.zoom);
      const nodes = cy.nodes();
      nodes.forEach((n) => {
        const task = n.data();
        if (task.x) {
          n.position("x", task.x);
          n.position("y", task.y);
        }
      });
      setTimeout(() => {
        nodes.forEach((n) => {
          const task = n.data();
          if (!task.x) {
            const connectedNodes = [
              ...n.incomers("node"),
              ...n.outgoers("node"),
            ];
            const deterministicallyPositionedOnes = connectedNodes.filter(
              (cn) => cn.data().x
            );
            if (deterministicallyPositionedOnes.length > 0) {
              const pos = deterministicallyPositionedOnes[0].position();
              console.log(
                "borrowing position of",
                deterministicallyPositionedOnes[0].data().title,
                pos
              );
              n.position("x", pos.x);
              n.position("y", pos.y);
            }
          }
        });
      }, 100);
      // nodes.filter((n) => !n.x).layout(layoutOpts);

      // cy.layout(layoutOpts).run();
      layoutDone = true;
      nodes.forEach((n) => {
        n.unlock();
      });
      cy.on("tap", function (e) {
        var currentTapStamp = e.timeStamp;
        var msFromLastTap = currentTapStamp - previousTapStamp;

        if (msFromLastTap < doubleClickDelayMs) {
          e.target.trigger("doubleTap", e);
        }
        previousTapStamp = currentTapStamp;
      });
      cy.on("doubleTap", (evt) =>
        console.log(this.$emit("selectedTask", evt.target.data().id))
      );

      if (cy.zoom() > cy.maxZoom()) {
        cy.zoom(cy.maxZoom());
      }
      if (cy.zoom() < cy.minZoom()) {
        cy.zoom(cy.minZoom());
      }
      window.mycy = cy;
      console.log("ft", this.focusedTask);
      const emitChange = () => this.$emit("taskChanged");
      const currentBoardId = this.currentBoardId;
      const emitSelect = (id) => this.$emit("selectedTask", id);
      cy.fit();
      cy.nodeHtmlLabel([
        {
          query: ".tnode", // cytoscape query selector
          halign: "center", // title vertical position. Can be 'left',''center, 'right'
          valign: "center", // title vertical position. Can be 'top',''center, 'bottom'
          halignBox: "center", // title vertical position. Can be 'left',''center, 'right'
          valignBox: "center", // title relative box vertical position. Can be 'top',''center, 'bottom'
          cssClass: "", // any classes will be as attribute of <div> container for every title
          tpl(data) {
            return `<div
            style="
              border-radius: 7px;
              width: 202px;
              height: 102px;
              opacity:0.8;
              position: relative;
              border: 5px solid green;
              overflow: hidden;
              display: flex;
              flex-direction: column;
              justify-content: space-around;
            ">
            <div
            style="
            padding:5px;
            text-align: center;
              "
            >
            ${htmlEntities(data.title)}
            </div>
            </span>`; // your html template here
          },
        },
      ]);

      cy.contextMenus({
        evtType: "cxttap",
        menuItems: [
          {
            id: "new",
            content: "new",
            tooltipText: "new",
            coreAsWell: true,
            // selector: "edge",
            onClickFunction: async function (evt) {
              console.log(evt);
              const newTask = await api.createNewTask(currentBoardId, {
                title: "new task",
                description: "",
              });
              console.log(newTask);
              nodePositions = cy.nodes().map((n) => {
                const task = n.data();
                if (task.title) {
                  return {
                    id: task.id,
                    x: n.position().x,
                    y: n.position().y,
                  };
                }
              });
              nodePositions.push({
                id: newTask.id,
                x: evt.position.x,
                y: evt.position.y,
              });
              await api.postLayout(currentBoardId, nodePositions);
              emitChange();
              setTimeout(() => {
                emitSelect(newTask.id);
              }, 1000);
            },
            show: true,
          },
          {
            id: "remove",
            content: "remove",
            tooltipText: "remove",
            selector: "edge",
            onClickFunction: async function (el) {
              const { source, target } = el.target.data();
              await api.unlink(target, source);
              emitChange();
            },
            show: true,
          },
          {
            id: "revert",
            content: "revert",
            tooltipText: "revert",
            selector: "edge",
            onClickFunction: async function (el) {
              const { source, target } = el.target.data();
              await api.unlink(target, source);
              await api.link(source, target);
              emitChange();
            },
            show: true,
          },
          {
            id: "edit",
            content: "edit",
            tooltipText: "edit",
            selector: "node",
            onClickFunction: async function (el) {
              console.log(el.target);
              emitSelect(el.target.data().id);
            },
            show: true,
          },
          {
            id: "||-->",
            content: "||-->",
            tooltipText: "||-->",
            selector: "node",
            onClickFunction: async function (evt) {
              creatingRequiredToArrow = evt.target.data();
              handle = cy.add({
                position: { x: evt.position.x + 20, y: evt.position.y + 20 },
                style: {
                  shape: "diamond",
                  width: 30,
                  height: 30,
                  backgroundColor: "red",
                },
              })[0];
              const edgeData = {
                group: "edges",
                data: {
                  source: evt.target.data().id,
                  target: handle.data().id,
                },
              };
              tmpEdge = cy.add(edgeData)[0];
              handle.position(evt.position);
            },
            show: true,
          },
          {
            id: "||<--",
            content: "||<--",
            tooltipText: "||<--",
            selector: "node",
            onClickFunction: async function (evt) {
              creatingDependsOnArrow = evt.target.data();
              handle = cy.add({
                position: { x: evt.position.x + 20, y: evt.position.y + 20 },
                style: {
                  shape: "diamond",
                  width: 30,
                  height: 30,
                  backgroundColor: "green",
                },
              })[0];
              const edgeData = {
                group: "edges",
                data: {
                  source: handle.data().id,
                  target: evt.target.data().id,
                },
              };
              tmpEdge = cy.add(edgeData)[0];
              handle.position(evt.position);
            },
            show: true,
          },
        ],
      });

      const getPan = () => {
        this.pan = cy.pan();
      };
      cy.on("mousemove", (evt) => {
        // console.log(evt);
        if (handle) {
          handle.position(evt.position);
        }
      });
      cy.on("dragfree", () => {
        this.saveLayout();
      });
      cy.on("click", async (evt) => {
        if (creatingRequiredToArrow || creatingDependsOnArrow) {
          handle.remove();
          handle = null;
          // debugger; // eslint-disable-line
          if (evt.target[0].data().title) {
            if (creatingDependsOnArrow) {
              await api.link(
                creatingDependsOnArrow.id,
                evt.target[0].data().id
              );
            }
            if (creatingRequiredToArrow) {
              await api.link(
                evt.target[0].data().id,
                creatingRequiredToArrow.id
              );
            }
            this.$emit("taskChanged");
          }
          creatingRequiredToArrow = null;
          creatingDependsOnArrow = null;
        }
        if (tmpEdge) {
          tmpEdge.remove();
          tmpEdge = null;
        }
      });
      cy.on("pan", debounce(getPan, 1000));
      const getZoom = () => {
        this.zoom = Number(cy.zoom()).toFixed(2);
      };
      cy.on("zoom", debounce(getZoom, 1000));
    },
  },
};
</script>

<style scoped></style>
